import api from '../..'

export const getQuestionList = (blockInstanceableId: number) => {
  return api
    .get(`administration/block_instances/${blockInstanceableId}/questions`)
    .then(({ data: { data } }) => {
      const result: any = []
      data.map(({ attributes }: any) => {
        const {
          id,
          name,
          description,
          explanationAnswer,
          order,
          questionableId,
          mandatory,
          questionableTypeHumanize,
          points,
          url,
          urlType,
          questionableType,
        } = attributes
        const {
          questionable: { values },
        } = attributes
        result.push({
          id,
          instanceId: blockInstanceableId,
          questionableId,
          name,
          explanationAnswer,
          description,
          order,
          mandatory,
          type: questionableTypeHumanize,
          questionableType,
          points: points || 0,
          url: url || '',
          urlType: urlType || 0,
          options: values || [],
        })
      })
      return result
    })
}
